import React from 'react';
import { get } from 'lodash';
import classNames from 'classnames';

import { getLabel } from 'utils/getLabel';
import { toggleField as ToggleField } from 'ui/views/generic/toggleField';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { hsaFsaIndicator as HsaFsaIndicator } from 'ui/views/widgets/hsaFsaIndicator';
 *
 * // render
 * <HsaFsaIndicator propName='propValue'/>
 */
export const hsaFsaIndicator = ( props ) => {

    const hsaFsaClassNames = classNames( 'ui-hsa-fsa-indicator', props.className );

    return (
        <div className={ hsaFsaClassNames }>
            <span className='ui-hsa-fsa-indicator__title'>
                { getLabel( get( props, 'title', {} ) ) }
            </span>

            <ToggleField
                onChange = { props.onChange }
                className = { 'ui-hsa-fsa-indicator__toggle' }
                height = { 12 }
                width = { 20 }
                value = { get( props, 'isHsaFsaEnabled' ) }
            />
        </div>
    );
};

// set display name
hsaFsaIndicator.displayName = 'hsaFsaIndicator';

// set default props
hsaFsaIndicator.defaultProps = {};

// prop types
hsaFsaIndicator.propTypes = {};
